import React, { useEffect, useRef, useState } from "react";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import MinusRoundIcon from "@rsuite/icons/MinusRound";
import { numberFormatter } from "../../utils";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { CSVLink } from "react-csv";

const L4SummaryTable = (props: any) => {
	const { data } = props;
	const [selectedL4, setSelectedL4] = useState<any>(null);
	const [exportData, setExportData] = useState([]);
	const exportFullRef = useRef<any>(null);
	const csvHeaders = [
		{ label: "L1", key: "l1" },
		{ label: "L2", key: "l2" },
		{ label: "L3", key: "l3" },
		{ label: "L4", key: "l4" },
		{ label: "SKU", key: "sku" },
		{ label: "Supplier", key: "supplier" },
		{ label: "Part Number", key: "MAN_PART_NO" },
		{ label: "Gross Margin (%)", key: "gm" },
		{ label: "Description", key: "itemDesc" },
		{ label: "Spend", key: "spend" },
	];

	const exportDataHandler = () => {
		let finalData: any = [];
		data.forEach((val: any) => {
			val?.skuData?.forEach((ele: any) => {
				let obj = {
					l1: val?.l1,
					l2: val?.l2,
					l3: val?.l3,
					l4: val?.l4,
					sku: ele?.sku,
					MAN_PART_NO: ele?.MAN_PART_NO,
					gm: `${(ele?.gm * 100).toFixed(2)}%`,
					itemDesc: ele?.itemDesc,
					spend: `$${parseFloat(ele?.spend).toFixed(0)}`,
					supplier: ele?.supplier,
				};
				finalData.push(obj);
			});
		});
		setExportData(JSON.parse(JSON.stringify(finalData)));
	};

	useEffect(() => {
		if (exportData?.length !== 0) {
			exportFullRef?.current?.link.click();
		}
	}, [exportData]);

	return (
		<>
			<table className="common-table-ui" style={{ height: "100%" }}>
				<thead>
					<tr>
						<th className="w-[60%]">TOP L4 Categories</th>
						{selectedL4 && <th>Top 20 SKUs</th>}
						{selectedL4 && <th>Supplier</th>}
						{selectedL4 && <th className="w-1/3">Description</th>}
						<th className="w-[20%]">Spend</th>
						<th className="w-[20%]">
							<div className="flex w-full">
								<span className="w-[90%] mt-1">
									Gross Margin {`(%)`}
								</span>
								<div>
									<FileDownloadIcon
										className="ml-[2vh] cursor-pointer mr-2"
										style={{
											background: "#9acd32b8",
											borderRadius: ".3vh",
											fill: "white",
										}}
										onClick={() => {
											exportDataHandler();
										}}
									/>
									<CSVLink
										ref={exportFullRef}
										data={exportData}
										headers={csvHeaders}
										filename="l4Summary.csv"
										className="hidden"
										target="_blank"
									></CSVLink>
								</div>
							</div>
						</th>
					</tr>
				</thead>
				<tbody>
					{props.data?.map((d: any, index: any) => {
						return (
							d.l4 && (
								<React.Fragment key={d.l4 + "_" + index}>
									<tr
										className={`${
											selectedL4 !== d.l4 &&
											selectedL4 !== null
												? "low-opacity"
												: ""
										}`}
									>
										<td>
											{selectedL4 === d.l4 ? (
												<MinusRoundIcon
													className="plusIcon"
													onClick={(e: any) => {
														setSelectedL4(null);
														// e.stopPropagation();
													}}
												/>
											) : (
												<PlusRoundIcon
													className="plusIcon"
													onClick={() => {
														setSelectedL4(d.l4);
													}}
												/>
											)}
											{d?.l4}
										</td>
										{selectedL4 && <td></td>}
										{selectedL4 && <td></td>}
										{selectedL4 && <td></td>}
										<td>
											{numberFormatter(d?.spend, 2, "$")}
										</td>
										<td>
											{numberFormatter(d?.gm * 100, 2)}%
										</td>
									</tr>
									{selectedL4 === d.l4 &&
										d?.skuData?.map(
											(s: any, skuIndex: any) => {
												return (
													<>
														<tr
															key={
																d.l4 +
																"_" +
																s.sku
															}
														>
															<td></td>
															<td>{s?.sku}</td>
															<td>
																{s?.supplier}
															</td>
															<td>
																{s?.itemDesc}
															</td>
															<td>
																{numberFormatter(
																	s?.spend,
																	2,
																	"$"
																)}
															</td>
															<td>
																{numberFormatter(
																	s?.gm * 100,
																	2
																)}
																%
															</td>
														</tr>
													</>
												);
											}
										)}
								</React.Fragment>
							)
						);
					})}
				</tbody>
			</table>
		</>
	);
};

export default L4SummaryTable;
